const emptyError = [];
class HTTPError extends Error {
    constructor(response, parsedResponse) {
        super(response.statusText);
        this.name = "HTTPError";
        this.status = response.status;
        this.error = parsedResponse ? parsedResponse.error : parsedResponse;
    }
}
export const getErrorResponseErrors = (error) => {
    if (error.error == null) {
        return emptyError;
    }
    else {
        return error.error.errors;
    }
};
export const getErrorsFromErrorResponse = async (errorResponse) => {
    const jsonResponse = await errorResponse.response.json();
    return getErrorResponseErrors(jsonResponse);
};
export const getErrorJSONFromErrorResponse = async (errorResponse) => {
    const jsonResponse = await errorResponse.response.json();
    if (jsonResponse.error === null) {
        return undefined;
    }
    else {
        return jsonResponse.error;
    }
};
export const getErrorResponseWithReason = (error, reason) => {
    const errors = getErrorResponseErrors(error);
    return errors.find((e) => e.reason === reason);
};
export const hasErrorResponseWithReason = (error, reason) => !!getErrorResponseWithReason(error, reason);
